// // export default EnterpriseLogin;
// import { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";   // ← CHANGE 1: add this import
// import { login } from "../../api/AuthApi";
// import "./Login.css";
// import Footer from "../common/Footer";
// import NavigationBar from "../common/NavigationBar";
// import SettingsModal from "./SettingsModal";
// import stm32Image from "./stm32.jpg";

// function EnterpriseLogin() {
//   const navigate = useNavigate();                        // ← CHANGE 2: add this line
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [showSettings, setShowSettings] = useState(false);

//   // Only show settings in the desktop app
//   const isElectron = typeof window !== "undefined" && window.electronAPI?.isElectron;

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setError("");

//     try {
//       const credentials = {
//         username: username,
//         password: password,
//       };

//       const response = await login(credentials);

//       // Store tokens in localStorage
//       if (response.data.access && response.data.refresh) {
//         localStorage.setItem("access_token", response.data.access);
//         localStorage.setItem("refresh_token", response.data.refresh);

//         // ← CHANGE 3: replace the isElectron branching with navigate()
//         // navigate() works for BOTH HashRouter (Electron) and BrowserRouter (web)
//         navigate("/", { replace: true });
//       } else {
//         throw new Error("No tokens received from server");
//       }
//     } catch (error) {
//       let errorMessage;

//       if (!navigator.onLine) {
//         errorMessage = "No internet connection. Please check your network.";
//       } else if (error.response === undefined) {
//         errorMessage = "Cannot connect to server. Please try again later.";
//       } else if (error.response?.status === 401) {
//         errorMessage =
//           error.response?.data?.detail ||
//           error.response?.data?.message ||
//           error.response?.data?.non_field_errors?.[0] ||
//           "Invalid username or password.";
//       } else if (error.response?.status === 404) {
//         errorMessage = "Login service unavailable. Please contact support.";
//       } else if (error.response?.status >= 500) {
//         errorMessage = "Server error. Please try again later.";
//       } else {
//         errorMessage = "Login failed. Please try again.";
//       }

//       setError(errorMessage);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <>
//       <NavigationBar />
//       <div className="enterprise-wrapper">
//         <div className="enterprise-login">
//           <div className="login-container">
//             {/* Left Side - Form Section */}
//             <div className="login-left">
//               <div className="form-container">
//                 <div className="form-header">
//                   <div className="header-main">
//                     <h1>Welcome back</h1>
//                     <p>Sign in to your Hayducate account</p>
//                   </div>
//                 </div>

//                 {error && (
//                   <div className="error-message">
//                     <div className="error-icon">⚠️</div>
//                     <div className="error-content">
//                       <span className="error-title">Authentication failed</span>
//                       <span className="error-message-text">{error}</span>
//                     </div>
//                   </div>
//                 )}

//                 <form onSubmit={handleLogin} className="login-form">
//                   <div className="form-group">
//                     <label>Username</label>
//                     <input
//                       type="text"
//                       placeholder="Enter your username"
//                       value={username}
//                       onChange={(e) => setUsername(e.target.value)}
//                       required
//                       disabled={isLoading}
//                       className={error ? "input-error" : ""}
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Password</label>
//                     <input
//                       type="password"
//                       placeholder="Enter your password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       required
//                       disabled={isLoading}
//                       className={error ? "input-error" : ""}
//                     />
//                   </div>

//                   <div className="form-options">
//                     <label className="remember-me">
//                       <input type="checkbox" />
//                       <span>Remember me</span>
//                     </label>
//                     {/* ← CHANGE 4: <a> → <Link> */}
//                     <Link to="/forgot-password" className="forgot-link">
//                       Forgot password?
//                     </Link>
//                   </div>

//                   <button
//                     type="submit"
//                     className="login-btn"
//                     disabled={isLoading}
//                   >
//                     {isLoading ? (
//                       <>
//                         <div className="loading-spinner"></div>
//                         Signing in...
//                       </>
//                     ) : (
//                       "Sign in"
//                     )}
//                   </button>
//                 </form>

//                 <div className="form-footer">
//                   <span>Don't have an account?</span>
//                   {/* ← CHANGE 4 (again): <a> → <Link> */}
//                   <Link to="/signup" className="signup-link">
//                     Create account
//                   </Link>
//                 </div>
//               </div>
//             </div>

//             {/* Right Side - Hero Section with Image */}
//             <div className="login-right">
//               <div className="hero-section">
//                 <div className="hero-image">
//                   <img src={stm32Image} alt="Online Learning" />
//                   <div className="hero-overlay">
//                     <div className="hero-content">
//                       <div className="brand-logo">
//                         <div className="logo-icon">H</div>
//                         <span className="logo-text">Hayducate</span>
//                       </div>
//                       <h1>Learn Without Limits</h1>
//                       <p>
//                         Start, switch, or advance your career with hands-on
//                         projects and career-focused learning paths.
//                       </p>
//                       <div className="hero-features">
//                         <div className="hero-feature">
//                           <span>Self-paced learning</span>
//                         </div>
//                         <div className="hero-feature">
//                           <span>Hands-on projects</span>
//                         </div>
//                         <div className="hero-feature">
//                           <span>Career-focused courses</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Settings Icon - Only in desktop app */}
//             {isElectron && (
//               <button
//                 className="login-settings-trigger"
//                 onClick={() => setShowSettings(true)}
//                 title="Settings"
//                 aria-label="Open settings"
//               >
//                 <i className="fas fa-cog"></i>
//               </button>
//             )}
//           </div>
//         </div>
//         <Footer />
//       </div>

//       {showSettings && (
//         <SettingsModal onClose={() => setShowSettings(false)} />
//       )}
//     </>
//   );
// }

// export default EnterpriseLogin;

// src/components/user_management/Login.jsx
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login } from "../../api/AuthApi";
import { useAuth } from "../../context/AuthContext";
import "./Login.css";
import Footer from "../common/Footer";
import NavigationBar from "../common/NavigationBar";
import SettingsModal from "./SettingsModal";
import stm32Image from "./stm32.jpg";

function EnterpriseLogin() {
  const navigate = useNavigate();
  const { login: contextLogin } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSettings, setShowSettings] = useState(false);

  const isElectron = typeof window !== "undefined" && window.electronAPI?.isElectron;

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const credentials = {
        username: username,
        password: password,
      };

      const response = await login(credentials);

      if (response.data.access && response.data.refresh) {
        // 1. Update AuthContext state AND persist tokens in one call.
        contextLogin(
          response.data.user || { username },
          {
            access: response.data.access,
            refresh: response.data.refresh,
          }
        );

        // 2. Check for a pending enrollment redirect from CourseHero.
        const rawRedirect = localStorage.getItem('enrollment_redirect');

        if (rawRedirect) {
          try {
            const parsed = JSON.parse(rawRedirect);

            // Ignore redirects older than 30 minutes
            const isFresh =
              parsed?.timestamp &&
              Date.now() - parsed.timestamp < 30 * 60 * 1000;

            if (isFresh && parsed?.courseSlug) {
              // Clean up so we don't redirect again later
              localStorage.removeItem('enrollment_redirect');

              // Paid course → support page; Free course → back to course page
              if (parsed.isFree) {
                navigate(`/course/${parsed.courseSlug}`, { replace: true });
              } else {
                navigate(`/course/${parsed.courseSlug}/support`, { replace: true });
              }
              return;
            }

            // Stale or malformed → discard
            localStorage.removeItem('enrollment_redirect');
          } catch {
            localStorage.removeItem('enrollment_redirect');
          }
        }

        // 3. No pending redirect → normal flow
        navigate("/", { replace: true });
      } else {
        throw new Error("No tokens received from server");
      }
    } catch (error) {
      let errorMessage;

      if (!navigator.onLine) {
        errorMessage = "No internet connection. Please check your network.";
      } else if (error.response === undefined) {
        errorMessage = "Cannot connect to server. Please try again later.";
      } else if (error.response?.status === 401) {
        errorMessage =
          error.response?.data?.detail ||
          error.response?.data?.message ||
          error.response?.data?.non_field_errors?.[0] ||
          "Invalid username or password.";
      } else if (error.response?.status === 404) {
        errorMessage = "Login service unavailable. Please contact support.";
      } else if (error.response?.status >= 500) {
        errorMessage = "Server error. Please try again later.";
      } else {
        errorMessage = "Login failed. Please try again.";
      }

      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <NavigationBar />
      <div className="enterprise-wrapper">
        <div className="enterprise-login">
          <div className="login-container">
            {/* Left Side - Form Section */}
            <div className="login-left">
              <div className="form-container">
                <div className="form-header">
                  <div className="header-main">
                    <h1>Welcome back</h1>
                    <p>Sign in to your Hayducate account</p>
                  </div>
                </div>

                {error && (
                  <div className="error-message">
                    <div className="error-icon">⚠️</div>
                    <div className="error-content">
                      <span className="error-title">Authentication failed</span>
                      <span className="error-message-text">{error}</span>
                    </div>
                  </div>
                )}

                <form onSubmit={handleLogin} className="login-form">
                  <div className="form-group">
                    <label>Username</label>
                    <input
                      type="text"
                      placeholder="Enter your username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                      disabled={isLoading}
                      className={error ? "input-error" : ""}
                    />
                  </div>

                  <div className="form-group">
                    <label>Password</label>
                    <input
                      type="password"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      disabled={isLoading}
                      className={error ? "input-error" : ""}
                    />
                  </div>

                  <div className="form-options">
                    <label className="remember-me">
                      <input type="checkbox" />
                      <span>Remember me</span>
                    </label>
                    <Link to="/forgot-password" className="forgot-link">
                      Forgot password?
                    </Link>
                  </div>

                  <button
                    type="submit"
                    className="login-btn"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <div className="loading-spinner"></div>
                        Signing in...
                      </>
                    ) : (
                      "Sign in"
                    )}
                  </button>
                </form>

                <div className="form-footer">
                  <span>Don't have an account?</span>
                  <Link to="/signup" className="signup-link">
                    Create account
                  </Link>
                </div>
              </div>
            </div>

            {/* Right Side - Hero Section with Image */}
            <div className="login-right">
              <div className="hero-section">
                <div className="hero-image">
                  <img src={stm32Image} alt="Online Learning" />
                  <div className="hero-overlay">
                    <div className="hero-content">
                      <div className="brand-logo">
                        <div className="logo-icon">H</div>
                        <span className="logo-text">Hayducate</span>
                      </div>
                      <h1>Learn Without Limits</h1>
                      <p>
                        Start, switch, or advance your career with hands-on
                        projects and career-focused learning paths.
                      </p>
                      <div className="hero-features">
                        <div className="hero-feature">
                          <span>Self-paced learning</span>
                        </div>
                        <div className="hero-feature">
                          <span>Hands-on projects</span>
                        </div>
                        <div className="hero-feature">
                          <span>Career-focused courses</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Settings Icon - Only in desktop app */}
            {isElectron && (
              <button
                className="login-settings-trigger"
                onClick={() => setShowSettings(true)}
                title="Settings"
                aria-label="Open settings"
              >
                <i className="fas fa-cog"></i>
              </button>
            )}
          </div>
        </div>
        <Footer />
      </div>

      {showSettings && (
        <SettingsModal onClose={() => setShowSettings(false)} />
      )}
    </>
  );
}

export default EnterpriseLogin;